<template>
  <div :class="{ 'is-invalid': showValidationError }">
    <label :for="inputId">
      <required v-if="required" />
      {{ i18n.t('activerecord.attributes.user.password') }}
    </label>
    <div class="input-group">
      <input :id="inputId" :type="inputType" :name="inputName" autocomplete="new-password"
             :class="['form-control form-control-lg', {'is-invalid': showValidationError}]" :value="value" @input="setValue">
      <button id="password-unmask-button" type="button" :class="['btn', {'is-invalid': showValidationError}]"
              @click="toggle">
        {{ buttonText }}
      </button>
    </div>
    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import Required from '../required'
import ValidationErrors from './validation-errors'

export default {
  components: { Required, ValidationErrors },

  props: {
    inputId: {
      type: String,
      required: false,
      default: 'user_password'
    },
    inputName: {
      type: String,
      required: false,
      default: 'user[password]'
    },
    required: {
      type: Boolean,
      required: false,
      default: true
    },
    validationErrors: {
      type: Array,
      required: false
    },
    value: {
      type: String,
      required: false
    }
  },

  emits: ['input'],

  data() {
    return {
      shown: false
    }
  },

  computed: {
    buttonText() {
      if (this.shown) {
        return this.i18n.t('administrative.hide')
      } else {
        return this.i18n.t('buttons.show')
      }
    },

    inputType() {
      return this.shown ? 'text' : 'password'
    },

    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  methods: {
    setValue(e) {
      this.$emit('input', e.target.value)
    },

    toggle() {
      this.shown = !this.shown
    }
  }
}
</script>

<style lang="scss" scoped>
// TODO: Move styles from app/assets/stylesheets/phoenix/_login.css.scss into the component.
// We currently cannot do this because the styles depend on the theme's SASS variables
// that are not available in webpack context.
#password-unmask-button.is-invalid {
  border-color: #dc3545;
}
</style>
